import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setServicesOpen(false);
  }, [location]);

  const services = [
    { name: 'Google Ads Management', path: '/services/google-ads', icon: '🎯' },
    { name: 'Local SEO', path: '/services/local-seo', icon: '📍' },
    { name: 'Technical SEO', path: '/services/technical-seo', icon: '🚀' },
    { name: 'Analytics & Reporting', path: '/services/analytics', icon: '📊' },
  ];

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'About', path: '/about' },
    { name: 'Process', path: '/process' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  const textColor = (!isHome || scrolled) ? '#333' : 'rgba(255,255,255,0.9)';

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      background: (!isHome || scrolled) ? 'rgba(255,255,255,0.98)' : 'transparent',
      backdropFilter: (!isHome || scrolled) ? 'blur(20px)' : 'none',
      boxShadow: (!isHome || scrolled) ? '0 4px 30px rgba(0,0,0,0.1)' : 'none',
      transition: 'all 0.3s ease'
    }}>
      <div style={{ maxWidth: 1400, margin: '0 auto', padding: '14px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 40, height: 40, background: 'linear-gradient(135deg, #ff6b35, #f54e00)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ color: 'white', fontWeight: 800, fontSize: 18 }}>C</span>
          </div>
          <span style={{ fontSize: 20, fontWeight: 700, color: (!isHome || scrolled) ? '#1a1a2e' : 'white' }}>Crescit Marketing</span>
        </Link>

        {/* Desktop Navigation */}
        <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
          {navLinks.slice(0, 1).map(link => (
            <Link key={link.path} to={link.path} style={{ color: textColor, fontWeight: 500, fontSize: 14, transition: 'color 0.3s' }}>
              {link.name}
            </Link>
          ))}
          
          {/* Services Dropdown */}
          <div 
            style={{ position: 'relative' }}
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            <span style={{ color: textColor, fontWeight: 500, fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
              Services
              <span style={{ fontSize: 10, transform: servicesOpen ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.3s' }}>▼</span>
            </span>
            
            {/* Dropdown Menu */}
            <div style={{
              position: 'absolute',
              top: '100%',
              left: -20,
              paddingTop: 15,
              opacity: servicesOpen ? 1 : 0,
              visibility: servicesOpen ? 'visible' : 'hidden',
              transform: servicesOpen ? 'translateY(0)' : 'translateY(-10px)',
              transition: 'all 0.3s ease'
            }}>
              <div style={{
                background: 'white',
                borderRadius: 16,
                boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                padding: 8,
                minWidth: 260,
                border: '1px solid #eee'
              }}>
                {services.map((service, i) => (
                  <Link
                    key={service.path}
                    to={service.path}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12,
                      padding: '12px 16px',
                      borderRadius: 10,
                      transition: 'background 0.2s',
                      color: '#333'
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <span style={{ fontSize: 24 }}>{service.icon}</span>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{service.name}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {navLinks.slice(1).map(link => (
            <Link key={link.path} to={link.path} style={{ color: textColor, fontWeight: 500, fontSize: 14, transition: 'color 0.3s' }}>
              {link.name}
            </Link>
          ))}

          <Link to="/contact" className="btn-primary" style={{ padding: '10px 22px', borderRadius: 50, fontSize: 14 }}>
            Free Consultation
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
